import { UpdateMetadata, PropertyPreviewMetadata, FieldType } from '../_services/report-template-design.service';
import { ReportProperties } from './report-properties';
import { Observable, Subject, Subscription } from 'rxjs';
import { TemplateDefinition } from './report-template';
import { TranslateService } from '@ngx-translate/core';
import { LangUpdateService } from '../_services/lang-update.service';

export class ReportPaperSize extends ReportProperties {

  public onUpdatePaperSize: Observable<UpdateMetadata>;
  private onUpdatePaperSize$: Subject<UpdateMetadata>;

  private baseDef: TemplateDefinition;
  private readonly metaPaperSize = 'paperSize';

  constructor(templateDef: TemplateDefinition,
    protected translate: TranslateService,
    protected langService: LangUpdateService
) {

    super('Paper Size', translate, langService);

    this.onUpdatePaperSize$ = new Subject();
    this.onUpdatePaperSize = this.onUpdatePaperSize$.asObservable();

    this.baseDef = templateDef;

    this.setChainUpdate();
    this.setPreviewMetadata();
  }

  public getPaperSize(): string {
    return this.baseDef.paperSize;
  }

  public getWidthNum(): number {
    let width: number;
    switch (this.baseDef.paperSize) {
      case 'Letter':
        width = 215.9;
        break;
      case 'Legal':
        width = 215.9;
        break;
      case 'A4':
        width = 210;
        break;
      case 'B5':
        width = 176;
        break;
      case 'B5JIS':
        width = 182;
        break;
    }
    return width;
  }
  public getWidth(): string {
    return [this.getWidthNum(), 'mm'].join('');
  }
  public getWidthPx(): number {
    return this.toPixel(this.getWidthNum(), 'mm');
  }

  public getHeightNum(): number {
    let height: number;
    switch (this.baseDef.paperSize) {
      case 'Letter':
        height = 279.4;
        break;
      case 'Legal':
        height = 355.6;
        break;
      case 'A4':
        height = 297;
        break;
      case 'B5':
        height = 250;
        break;
      case 'B5JIS':
        height = 257;
        break;
    }
    return height;
  }
  public getHeight(): string {
    return [this.getHeightNum(), 'mm'].join('');
  }
  public getHeightPx(): number {
    return this.toPixel(this.getHeightNum(), 'mm');
  }

  public getTemplateJSON(): TemplateDefinition {
    return this.baseDef;
  }

  public getPreviewMetadata(): PropertyPreviewMetadata[] {
    return [
      {
        name: this.metaPaperSize, parentName: null, value: '',
        isFieldType: (type: FieldType): boolean => type === 'Select',
        selectItems: [
          { label: 'Letter', value: 'Letter' },
          { label: 'Legal', value: 'Legal' },
          { label: 'A4', value: 'A4' },
          { label: 'B5(ISO)', value: 'B5' },
          { label: 'B5(JIS)', value: 'B5JIS' },
        ],
        isRequired: true,
        isEdited: false,
        isDisplay: true,
      }
    ];
  }

  protected setUpdateMetadata(metadata: UpdateMetadata) {
    switch (metadata.name) {
      case this.metaPaperSize:
        this.baseDef[metadata.name] = metadata.value as string;
        this.setPreviewValue(metadata.name, metadata.value);
        this.onUpdatePaperSize$.next(metadata);
        break;
    }
  }
  protected setChainUpdateFunction(subscribers: Array<Subscription>) { }
}
